export default __webpack_public_path__ + "static/media/ntv-brands-white.0bd5b0e4.png";